import { AxiosError } from "axios";


export class Chat42Error extends Error {
    constructor(public code: string) {
        super(code);
        Object.setPrototypeOf(this, Chat42Error.prototype);
    }

    public readonly isChat42Error = true;
}

export const isChat42Error = (error: unknown): error is Chat42Error => {
    try {
        if (!error
                || typeof error !== "object"
                || !("isChat42Error" in error)
                || typeof error.isChat42Error !== "boolean"
        ) {
            return false;
        }
        return true;
    } catch (e) {
        return false;
    }
};

export const isAxiosError = (error: unknown): error is AxiosError => {
    try {
        if (!error
                || typeof error !== "object"
                || !("isAxiosError" in error)
                || typeof error.isAxiosError !== "boolean"
        ) {
            return false;
        }
        return true;
    } catch (e) {
        return false;
    }
};

export const isSessionExpiredError = (error: unknown): error is AxiosError => {
    return isAxiosError(error) && error?.response?.status === 401;
};
